import React, { useState } from 'react';

export const ProtoPanel = ({ theme, view, onChangeView }) => {
  const c = theme.colors;
  const t = theme.typography || {};
  const [open, setOpen] = useState(false);

  const items = [
    { key: 'signin',          label: 'Sign-in',                    view: { name: 'signin' } },
    { key: 'home',            label: 'Home',                       view: { name: 'home' } },
    { key: 'thunder-king',    label: 'Campaign: Thunder King',     view: { name: 'campaign', id: 'thunder-king' } },
    { key: 'lockhood',        label: 'Campaign: Lockhood',         view: { name: 'campaign', id: 'lockhood' } },
    { key: 'abyss',           label: 'Campaign: The Abyss',        view: { name: 'campaign', id: 'abyss' } },
    { key: 'thunder-king-v2', label: 'Campaign v2: Thunder King',  view: { name: 'campaign-v2', id: 'thunder-king' } },
    { key: 'lockhood-v2',     label: 'Campaign v2: Lockhood',      view: { name: 'campaign-v2', id: 'lockhood' } },
    { key: 'abyss-v2',        label: 'Campaign v2: The Abyss',     view: { name: 'campaign-v2', id: 'abyss' } },
  ];

  const currentKey =
    view.name === 'signin' ? 'signin'
    : view.name === 'home' ? 'home'
    : view.name === 'campaign-v2' ? `${view.id}-v2`
    : view.id;

  return (
    <div style={{
      position: 'fixed',
      top: 16, right: 16,
      zIndex: 1000,
      fontFamily: t.fontFamily,
    }}>
      {!open ? (
        <button
          onClick={() => setOpen(true)}
          style={{
            background: c.bgCardSolid,
            border: `1px solid ${c.borderPrimary}`,
            color: c.textSecondary,
            padding: '6px 12px',
            borderRadius: 999,
            fontSize: '0.72rem',
            letterSpacing: '0.14em',
            cursor: 'pointer',
            fontFamily: t.fontFamily,
            textTransform: 'uppercase',
            fontWeight: 700,
          }}
        >Proto</button>
      ) : (
        <div style={{
          background: c.bgCardSolid,
          border: `1px solid ${c.borderPrimary}`,
          borderRadius: 8,
          padding: 10,
          minWidth: 220,
          boxShadow: '0 8px 24px rgba(0,0,0,0.6)',
        }}>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            marginBottom: 8,
          }}>
            <span style={{
              fontSize: '0.66rem', letterSpacing: '0.22em',
              color: c.textMuted, fontWeight: 700,
              textTransform: 'uppercase',
            }}>Prototype View</span>
            <button
              onClick={() => setOpen(false)}
              style={{
                background: 'none', border: 'none',
                color: c.textMuted, cursor: 'pointer',
                fontSize: '0.86rem',
              }}
            >×</button>
          </div>
          {items.map(item => {
            const active = item.key === currentKey;
            return (
              <button
                key={item.key}
                onClick={() => onChangeView(item.view)}
                style={{
                  display: 'block', width: '100%',
                  padding: '7px 10px',
                  marginBottom: 2,
                  background: active ? `${c.accent}22` : 'transparent',
                  border: `1px solid ${active ? c.accent : 'transparent'}`,
                  borderRadius: 6,
                  color: active ? c.accentLight : c.textSecondary,
                  fontSize: '0.78rem',
                  cursor: 'pointer',
                  textAlign: 'left',
                  fontFamily: t.fontFamily,
                  fontWeight: active ? 600 : 400,
                }}
              >{item.label}</button>
            );
          })}
        </div>
      )}
    </div>
  );
};
